import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { slateToHtml } from 'slate-serializers'
import { CheckCircleIcon, } from "@heroicons/react/24/outline";
import WYWSGI from "../../../components/atoms/wywsgi";
import Loader from "../../../components/atoms/loader";
import InlineLoader from "../../../components/atoms/inlineLoader";
import { useStore } from "../../../store";


import Axios from "../../../AxiosConfig";
const ViewSupport = () => {
    const { layoutStore } = useStore();
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState("");
    const [messages, setMessages] = useState([]);
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    useEffect(() => {
        // Get the ticket ID from the URL
        setLoading(true);
        const ticketId = location.pathname.split("/").pop();
        Axios.post("/support/info", {
            ticketId,
        }).then((res) => {
            if (res.data.success) {
                console.log(res.data);
                setTitle(res.data.title);
                setStatus(res.data.status);
                let messages = res.data.messages.map((message) => {
                    return {
                        ...message,
                        html: slateToHtml(JSON.parse(message.message))
                    }
                });
                setMessages(messages);
                setLoading(false);
            } else {
                layoutStore.showToaster(res.data.error, "error");
                setLoading(false);
                navigate("/support");
            }
        }).catch((error) => {
            layoutStore.showToaster(`${error} :: ${ticketId}`, "error");
            setLoading(false);
            navigate("/support");
        });
    }, []);

    const raiseTicket = async () => {
        setLoading(true);
        const uuid = location.pathname.split("/").pop();
        Axios.post("/support/new-message", {
            uuid,
            message: JSON.stringify(message),
        }).then((res) => {
            if (res.data.success) {
                layoutStore.showToaster("Ticket raised successfully", "success");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                layoutStore.showToaster(res.data.error, "error");
                setLoading(false);
            }
        });
    };
    const toggleStatus = async () => {
        setLoading(true);
        const uuid = location.pathname.split("/").pop();
        Axios.post("/support/toggle-status", {
            uuid,
            status
        }).then((res) => {
            if (res.data.success) {
                layoutStore.showToaster("Status updated successfully", "success");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                layoutStore.showToaster(res.data.error, "error");
                setLoading(false);
            }
        });
    };
    const goBackButton = () => {
        navigate('/support')
    }

    return (
        <>
            {loading && <Loader />}
            <button
                type="button"
                onClick={goBackButton}
                className="mb-6 inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                Back
            </button>
            <div className="bg-white py-8 px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-left">
                    <h2 className="text-4xl font-bold tracking-tight text-gray-900">
                        {title}
                    </h2>
                    <div className="pt-4 border-t mt-3">
                        <button
                            type="button"
                            onClick={toggleStatus}
                            className="inline-flex items-center rounded border ml-3 border-gray-300 bg-white px-5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            {
                                status === "active" ?
                                    <> <CheckCircleIcon className="h-5 w-5 mr-2 inline text-green-600" />    Mark As Resolved</> :
                                    <> <CheckCircleIcon className="h-5 w-5 mr-2 inline text-red-600" />    Re Open Case</>
                            }

                        </button>
                    </div>
                    <div className="mt-6">
                        {messages.map((message, index) => {

                            return <div
                                key={index}
                                className="p-4 border-t mb-4"
                            >
                                <div className="flex justify-between">
                                    <strong className="text-blue-800">
                                        {
                                            message.reply ? "Admin" : "You"
                                        }
                                    </strong>
                                    <span className="text-gray-600">
                                        {
                                            new Date(message.created_at).toLocaleString()
                                        }
                                    </span>
                                </div>
                                <div
                                    className="mt-4"
                                    dangerouslySetInnerHTML={{ __html: message.html }}
                                >
                                </div>
                            </div>

                        })}
                    </div>
                    {
                        status === "active" &&
                        <div className="pt-6 border-t">
                            <div className="mt-2">
                                <WYWSGI
                                    setParent={setMessage}
                                />
                            </div>
                            <div className="mt-2 text-right">
                                <button
                                    type="button"
                                    onClick={raiseTicket}
                                    className="inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                    {loading ? <InlineLoader /> : "Submit"}
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    );
};
export default ViewSupport;